var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCheckCirclePrimary = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0013 2.66602C8.65464 2.66602 2.66797 8.65268 2.66797 15.9993C2.66797 23.346 8.65464 29.3327 16.0013 29.3327C23.348 29.3327 29.3346 23.346 29.3346 15.9993C29.3346 8.65268 23.348 2.66602 16.0013 2.66602ZM22.3746 12.9327L14.8146 20.4927C14.628 20.6793 14.3746 20.786 14.108 20.786C13.8413 20.786 13.588 20.6793 13.4013 20.4927L9.62797 16.7193C9.2413 16.3327 9.2413 15.6927 9.62797 15.306C10.0146 14.9193 10.6546 14.9193 11.0413 15.306L14.108 18.3727L20.9613 11.5194C21.348 11.1327 21.988 11.1327 22.3746 11.5194C22.7613 11.906 22.7613 12.5327 22.3746 12.9327Z",
    fill: "#3BB700"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheckCirclePrimary, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/check-circle-primary.063aa4f3.svg";
export { ForwardRef as ReactComponent };